export const MAZDA_CHECKLIST_SERVICE_CODE = 'MAZDA_PORTAL-CHECKLIST';
